import template from './sw-cms-el-preview-text.html.twig';
import './sw-cms-el-preview-text.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
